export const Housing = {
    comforts: [
        {
            key: 'comfort:wifi',
            label: 'Wifi',
            value: false,
        },
        {
            key: 'comfort:restaurant',
            label: 'Restaurang',
            value: false,
        },
        {
            key: 'comfort:parking',
            label: 'Parkering',
            value: false,
        },
        {
            key: 'comfort:24_hour_reception',
            label: '24-timmars reception',
            value: false,
        },
        {
            key: 'comfort:handicapped_friendly',
            label: 'Handikappvänligt',
            value: false,
        },
        {
            key: 'comfort:pets_allowed',
            label: 'Husdjur tillåtna',
            value: false,
        },
        {
            key: 'comfort:breakfast',
            label: 'Frukost ingår',
            value: false,
        },
        {
            key: 'comfort:child_friendly',
            label: 'Barnvänligt',
            value: false,
        },
    ],
};
